import request from '@/utils/request'

export default {
    fetchData(filters) {
        const requestUrl = filters ? '/reviews?' : '/reviews'
        return request.get(requestUrl + new URLSearchParams(filters))
    }
}
